import React, {Component} from 'react';
import {connect} from 'react-redux'
import {ModalBody, Input} from 'reactstrap';
import {fetchReset} from './../actions/postReset'
import {Loader} from './../../../components/loader'

class Reset extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
        };
        this.confirmAction = this.confirmAction.bind(this);
        this.modalLine = this.modalLine.bind(this);
        this.changeInput = this.changeInput.bind(this);
    }

    confirmAction() {
        let state = this.state;
        let props = this.props;
        const {dispatch} = props;
        let data = {
            email: state.email,
        };
        dispatch(fetchReset(data));

    }

    modalLine(content) {
        return (
            <div className="modal-line mt-4">
                {content()}
            </div>
        );
    }

    changeInput(event) {
        let id = event.target.id;
        let state = {};
        state[id] = event.target.value;
        this.setState({...state});
    }

    render() {
        let props = this.props;
        let state = this.state;
        let isFetching = props.isFetching;
        return (
            <div>
                <div className="modal-scroll">
                    {
                        isFetching ? <Loader/> : null
                    }
                    <ModalBody>
                        {this.modalLine(() => (
                            <Input value={state.email} id={'email'} placeholder="Email" onChange={this.changeInput}/>
                        ))}
                        <div className="submit-button-container mt-4">
                            <div className="submit-button mt-2 pointer-no-select" onClick={this.confirmAction}>
                                Восстановить
                            </div>
                        </div>
                    </ModalBody>
                </div>
            </div>
        )
    }
}

const MapStateToProps = function mapStateToProps(state) {
    return {
        isFetching: state.authState.reset.isFetching,
        route: state.appState.route,
    }
};

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        closeModal: () => {
            dispatch({type: 'closeMiniModal',});
        },
        dispatch
    };
};


export const ResetLink = connect(MapStateToProps, mapDispatchToProps)(Reset);